import React, { useCallback } from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { trackEvent } from '@surfline/web-common';

import styles from './TableHeaderHourlyToggle.module.scss';

interface Props {
  isHourlyExpanded: boolean;
  onToggleHourly: () => void;
  spotId?: string;
  spotName?: string;
  subregionId?: string;
  subregionName?: string;
}

const TableHeaderHourlyToggle: React.FC<Props> = ({
  isHourlyExpanded,
  onToggleHourly,
  spotId,
  spotName,
  subregionId,
  subregionName,
}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;
      trackEvent('Clicked Toggle', {
        pageName: 'Spot Page',
        spotId,
        spotName,
        subregionId,
        subregionName,
        toggleEnd: checked ? 'on' : 'off',
        toggleStart: checked ? 'off' : 'on',
        toggleType: 'table view hourly',
      });
      onToggleHourly();
    },
    [onToggleHourly, spotId, spotName, subregionId, subregionName],
  );

  return (
    <Box className={styles.wrapper}>
      <FormControlLabel
        control={
          <Switch
            checked={isHourlyExpanded}
            data-testid="forecast-table-day-hourly-toggle"
            onChange={handleChange}
            size="small"
          />
        }
        label={
          <Box className={styles.labelContent} component="span">
            <span className={styles.desktopLabel}>
              <Typography variant="footnote">Show hourly data when expanded</Typography>
            </span>
            <span className={styles.mobileLabel}>
              <Typography variant="footnote">Hourly</Typography>
            </span>
          </Box>
        }
      />
    </Box>
  );
};

export default TableHeaderHourlyToggle;
